import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from 'src/environments/environment';
import { catchError, tap } from 'rxjs/operators';
import { throwError } from 'rxjs';


@Injectable({
  providedIn: 'root'
})
export class SettingsService {
  url = environment.url;

  constructor(public http: HttpClient) { }

  getModules() {
    return this.http.get(`${this.url}` + '/settings/modules').pipe(tap(res => res),
      catchError(err => throwError(new Error('Issue in getting settings'))),
    );
  }

  updateModules(module: any) {
    return this.http.put(`${this.url}` + '/settings', module).pipe(tap(res => res),
        catchError(err => throwError(new Error('Issue in getting settings'))),
    );
  }

  getAll() {
    return this.http.get(`${this.url}` + '/settings').pipe(tap(res => res),
        catchError(err => throwError(()=>err)));
  }
}
